import { Action } from "redux"
import { Workspace } from "../../models"

export const REQUEST_WORKSPACES = "WORKSPACELISTPAGE_REQUEST_WORKSPACES"

export const requestWorkspaces = (): Action => ({ type: REQUEST_WORKSPACES })

export const RECEIVE_WORKSPACES = "WORKSPACELISTPAGE_RECEIVE_WORKSPACES"

export interface ReceiveWorkspaces extends Action {
    count: number
    workspaces: Workspace[]
}

export const receiveWorkspaces = (
    count: number,
    workspaces: Workspace[],
): ReceiveWorkspaces => ({ type: RECEIVE_WORKSPACES, count, workspaces })

export const LOAD_MORE_WORKSPACES = "WORKSPACELISTPAGE_LOAD_MORE_WORKSPACES"

export const loadMoreWorkspaces = (): Action => ({ type: LOAD_MORE_WORKSPACES })

export const FILTER_WORKSPACES = "WORKSPACELISTPAGE_FILTER_WORKSPACES"

export interface Filter extends Action {
    code: string
    label: string
    isActive: boolean
}

export const filterWorkspaces = (
    code: string,
    label: string,
    isActive: boolean,
): Filter => ({ type: FILTER_WORKSPACES, code, label, isActive })

export const REFRESH_WORKSPACES = "WORKSPACELISTPAGE_REFRESH_WORKSPACES"

export const refreshWorkspaces = (): Action => ({ type: REFRESH_WORKSPACES })

export const mapDispatchToProps = {
    requestWorkspaces,
    receiveWorkspaces,
    filterWorkspaces,
    loadMoreWorkspaces,
    refreshWorkspaces,
}

export type DispatchProps = typeof mapDispatchToProps
